<template>
  <div>
    <loader v-if="loading" />
    <template v-else>
      <div class="mb-md-3">
        <!-- Info Guide -->
        <info-guide
          v-if="guideVisibleFirstTime"
          type="employeesAndPayrollExamples"
          visible
          @click="closeInfoFirstTime"
        />
        <!-- /Info Guide -->

        <div class="d-flex justify-content-end margin-guide-not-visible" />
      </div>
    </template>

    <!-- Payroll Expenses Tabs -->
    <payroll-expenses-tabs v-if="!loading" class="mb-4" :disabled="aiTemplateLoader" />
    <!-- /Payroll Expenses Tabs -->

    <!-- Payroll Expenses List -->
    <payroll-expenses-list class="mb-4" :disabled="aiTemplateLoader" />
    <!-- /Payroll Expenses List -->

    <!-- Add More Details -->
    <add-more-details
      v-if="!loading"
      :category="'setup'"
      :step="'staffAndPayroll'"
      :concept-name="'employeesAndPayrollMoreDetails'"
      :completed-step-name="'employeesAndPayrollCompleted'"
    />
    <!-- /Add More Details -->

    <!-- Info Guide Drawer -->
    <info-guide-drawer
      type="employeesAndPayrollExamples"
      :visible="guideVisible"
      @close="guideVisible = false;"
    />
    <!-- /Info Guide Drawer -->

    <!-- Ai Buddy Drawer -->
    <ai-buddy-drawer
      :visible="aiBuddyDrawerVisible"
      type="staffAndPayroll"
      @close="aiBuddyDrawerVisible = false"
    />
    <!-- /Ai Buddy Drawer -->

  </div>
</template>

<script>
import { mapState } from 'vuex'

import AddMoreDetails from '@/views/Home/StoryMode/Components/AddMoreDetails.vue'
import AiBuddyDrawer from '@/views/Home/StoryMode/Components/AiBuddy/AiBuddyDrawer.vue'
import EventBus from '@/event-bus'
import InfoGuide from '@/views/Home/StoryMode/Components/Example/InfoGuide.vue'
import InfoGuideDrawer from '@/views/Home/StoryMode/Components/Example/InfoGuideDrawer.vue'
import Loader from '@/components/Loader'
import MixinAiBuddyDrawer from '@/mixins/aiBuddyDrawer'
import MixinAiTemplate from '@/mixins/aiTemplate'
import MixinApiCalculations from '@/mixins/apiCalculations'
import MixinGuide from '@/mixins/guide'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import PayrollExpensesList from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/PayrollExpense/PayrollExpensesList.vue'
import PayrollExpensesTabs from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/PayrollExpense/PayrollExpensesTabs.vue'

export default {
  name: 'ExpensesStaffAndPayroll',

  components: {
    AddMoreDetails,
    PayrollExpensesList,
    PayrollExpensesTabs,
    InfoGuide,
    AiBuddyDrawer,
    InfoGuideDrawer,
    Loader
  },

  mixins: [MixinApiCalculations, MixinGuide, MixinIdeaRoles, MixinAiBuddyDrawer, MixinAiTemplate],

  data () {
    return {
      loading: false,
      dialogAddNewVisible: false
    }
  },

  computed: {
    ...mapState(['idea'])
  },

  mounted () {
    this.openGuide('staffPayrollFinancialPlanGuide')

    EventBus.$on('loading', (payload) => {
      this.loading = payload
    })

    EventBus.$on('open-info', () => {
      this.guideVisible = true
    })

    EventBus.$on('close-info-first-time', () => {
      this.guideVisibleFirstTime = false
    })
  },

  beforeDestroy () {
    EventBus.$off('loading')
    EventBus.$off('open-info')
    EventBus.$off('close-info-first-time')
  }
}
</script>
